/**
 * Checklist Meta App Review — mapeia requisitos → status real no Oficial.
 * status:
 *  available = feature existe no sistema (verde)
 *  configure = parcial / precisa configurar (âmbar)
 *  external  = passo só no Meta Dashboard (cinza)
 *  manual    = prova / vídeo App Review (cinza-azulado)
 */

export const STATUS = {
  available: "available",
  configure: "configure",
  external: "external",
  manual: "manual",
};

export const META_DOCS = {
  coexistence:
    "https://developers.facebook.com/docs/whatsapp/cloud-api/guides/set-up-whatsapp-coexistence",
  appReview:
    "https://developers.facebook.com/docs/app-review",
  messaging:
    "https://developers.facebook.com/docs/whatsapp/cloud-api",
  privacy:
    "https://developers.facebook.com/docs/development/release/app-review/requirements#privacy-policy",
};

export const checklistSections = [
  {
    id: "messaging",
    permission: "whatsapp_business_messaging",
    titleKey: "metaOnboarding.sections.messaging",
    items: [
      {
        id: "msg_send",
        titleKey: "metaOnboarding.items.msgSend.title",
        descKey: "metaOnboarding.items.msgSend.desc",
        tipKey: "metaOnboarding.items.msgSend.tip",
        status: STATUS.available,
        links: [{ to: "/tickets", labelKey: "metaOnboarding.links.tickets" }],
        proofKey: null,
      },
      {
        id: "msg_receive",
        titleKey: "metaOnboarding.items.msgReceive.title",
        descKey: "metaOnboarding.items.msgReceive.desc",
        tipKey: "metaOnboarding.items.msgReceive.tip",
        status: STATUS.available,
        links: [
          { to: "/tickets", labelKey: "metaOnboarding.links.inbox" },
          { to: "/webhook", labelKey: "metaOnboarding.links.webhook" },
          { to: "/waba", labelKey: "metaOnboarding.links.wabaWebhooks" },
        ],
        proofKey: null,
      },
      {
        id: "msg_ack",
        titleKey: "metaOnboarding.items.msgAck.title",
        descKey: "metaOnboarding.items.msgAck.desc",
        tipKey: "metaOnboarding.items.msgAck.tip",
        status: STATUS.available,
        links: [{ to: "/tickets", labelKey: "metaOnboarding.links.tickets" }],
        proofKey: null,
      },
      {
        id: "msg_proof",
        titleKey: "metaOnboarding.items.msgProof.title",
        descKey: "metaOnboarding.items.msgProof.desc",
        tipKey: "metaOnboarding.items.msgProof.tip",
        status: STATUS.manual,
        links: [{ to: "/tickets", labelKey: "metaOnboarding.links.tickets" }],
        proofKey: "proof_msg_video",
      },
    ],
  },
  {
    id: "management",
    permission: "whatsapp_business_management",
    titleKey: "metaOnboarding.sections.management",
    items: [
      {
        id: "mgmt_connect",
        titleKey: "metaOnboarding.items.mgmtConnect.title",
        descKey: "metaOnboarding.items.mgmtConnect.desc",
        tipKey: "metaOnboarding.items.mgmtConnect.tip",
        status: STATUS.available,
        links: [
          { to: "/waba-signup", labelKey: "metaOnboarding.links.embeddedSignup" },
          { to: "/connections", labelKey: "metaOnboarding.links.connections" },
        ],
        proofKey: null,
      },
      {
        id: "mgmt_templates",
        titleKey: "metaOnboarding.items.mgmtTemplates.title",
        descKey: "metaOnboarding.items.mgmtTemplates.desc",
        tipKey: "metaOnboarding.items.mgmtTemplates.tip",
        status: STATUS.configure,
        links: [
          { to: "/waba", labelKey: "metaOnboarding.links.wabaTemplates" },
          {
            href: "https://business.facebook.com/wa/manage/message-templates/",
            labelKey: "metaOnboarding.links.metaTemplates",
            external: true,
          },
        ],
        proofKey: null,
      },
      {
        id: "mgmt_sync",
        titleKey: "metaOnboarding.items.mgmtSync.title",
        descKey: "metaOnboarding.items.mgmtSync.desc",
        tipKey: "metaOnboarding.items.mgmtSync.tip",
        status: STATUS.available,
        links: [{ to: "/waba", labelKey: "metaOnboarding.links.wabaSync" }],
        proofKey: null,
      },
      {
        id: "mgmt_webhook",
        titleKey: "metaOnboarding.items.mgmtWebhook.title",
        descKey: "metaOnboarding.items.mgmtWebhook.desc",
        tipKey: "metaOnboarding.items.mgmtWebhook.tip",
        status: STATUS.available,
        links: [
          { to: "/waba", labelKey: "metaOnboarding.links.wabaWebhooks" },
          { to: "/webhook", labelKey: "metaOnboarding.links.webhook" },
        ],
        proofKey: null,
      },
      {
        id: "mgmt_proof",
        titleKey: "metaOnboarding.items.mgmtProof.title",
        descKey: "metaOnboarding.items.mgmtProof.desc",
        tipKey: "metaOnboarding.items.mgmtProof.tip",
        status: STATUS.manual,
        links: [
          { to: "/waba", labelKey: "metaOnboarding.links.waba" },
          { to: "/waba-signup", labelKey: "metaOnboarding.links.embeddedSignup" },
        ],
        proofKey: "proof_mgmt_video",
      },
      {
        id: "mgmt_coexistence",
        titleKey: "metaOnboarding.items.mgmtCoexistence.title",
        descKey: "metaOnboarding.items.mgmtCoexistence.desc",
        tipKey: "metaOnboarding.items.mgmtCoexistence.tip",
        status: STATUS.configure,
        links: [
          { to: "/waba-signup", labelKey: "metaOnboarding.links.embeddedSignup" },
          { to: "/waba", labelKey: "metaOnboarding.links.waba" },
          {
            href: META_DOCS.coexistence,
            labelKey: "metaOnboarding.links.coexistenceDocs",
            external: true,
          },
        ],
        proofKey: "proof_coexistence",
      },
    ],
  },
  {
    id: "prerequisites",
    permission: null,
    titleKey: "metaOnboarding.sections.prerequisites",
    items: [
      {
        id: "pre_dev_account",
        titleKey: "metaOnboarding.items.preDevAccount.title",
        descKey: "metaOnboarding.items.preDevAccount.desc",
        tipKey: "metaOnboarding.items.preDevAccount.tip",
        status: STATUS.external,
        links: [
          {
            href: "https://developers.facebook.com/",
            labelKey: "metaOnboarding.links.metaDevelopers",
            external: true,
          },
        ],
        proofKey: "proof_dev_account",
      },
      {
        id: "pre_privacy_terms",
        titleKey: "metaOnboarding.items.prePrivacy.title",
        descKey: "metaOnboarding.items.prePrivacy.desc",
        tipKey: "metaOnboarding.items.prePrivacy.tip",
        status: STATUS.configure,
        links: [
          {
            href: META_DOCS.privacy,
            labelKey: "metaOnboarding.links.metaPrivacy",
            external: true,
          },
          { to: "/settings", labelKey: "metaOnboarding.links.settings" },
        ],
        proofKey: "proof_privacy_terms",
        showPolicyFields: true,
      },
      {
        id: "pre_business_info",
        titleKey: "metaOnboarding.items.preBusiness.title",
        descKey: "metaOnboarding.items.preBusiness.desc",
        tipKey: "metaOnboarding.items.preBusiness.tip",
        status: STATUS.external,
        links: [
          {
            href: "https://developers.facebook.com/apps/",
            labelKey: "metaOnboarding.links.metaAppDashboard",
            external: true,
          },
        ],
        proofKey: "proof_business_info",
      },
      {
        id: "pre_videos",
        titleKey: "metaOnboarding.items.preVideos.title",
        descKey: "metaOnboarding.items.preVideos.desc",
        tipKey: "metaOnboarding.items.preVideos.tip",
        status: STATUS.manual,
        links: [
          {
            href: META_DOCS.appReview,
            labelKey: "metaOnboarding.links.appReviewDocs",
            external: true,
          },
        ],
        proofKey: "proof_videos_per_permission",
      },
    ],
  },
];
